<template>
  <a-form-model
    ref="ruleForm"
    :model="form"
    :rules="rules"
    class="demo__FormModal demo__align-left demo__margin-top--8"
  >
    <a-form-model-item
      :ref="field.key"
      :prop="field.key"
      :label="field.label"
      v-for="field in filteredStepFields"
      :key="field.key"
      class="demo__margin-top--16 demo__margin-bottom--0"
      v-bind:class="{
        'demo__FormModal--required': field.required,
      }"
    >
      <a-input
        v-if="!field.select"
        v-model="form[field.key]"
        class="demo__input"
      />
      <a-select
        v-else-if="field.select?.mode !== 'autocomplete'"
        :mode="field.select.mode"
        v-model="form[field.key]"
        class="demo__radius--4"
        v-bind:class="[`demo__Select--${field.select.mode}`]"
        :dropdown-class-name="`demo__Select--${field.select.mode}-dropdown`"
        showArrow
        :showSearch="false"
        @change="field.select.onSearch || false"
        optionFilterProp="children"
        :maxTagCount="mxTagCountSelector"
        :maxTagTextLength="mxTagTextLength"
        :get-popup-container="scssRoot"
      >
        <a-select-option
          v-for="option in selectOptions[field.key]"
          :key="option.id"
        >
          {{ option.name }}
        </a-select-option>
      </a-select>
      <FuseAutocomplete
        v-else
        :data="selectOptions[field.key]"
        :on-select="field.select.onSelect"
        :placeholder="$t('Start type')"
      />
    </a-form-model-item>
    <a-form-model-item class="demo__margin-top--24">
      <div class="demo__flex demo__flex-middle demo__flex-between">
        <div
          class="demo__font--16 demo__weight--600 demo__color--black demo__flex demo__flex-middle demo__pointer"
          @click="$root.$emit('changeRegStep', 1)"
        >
          <i class="fa-regular fa-chevron-left demo__margin-right--12"></i>
          <div>
            {{ $t("Back") }}
          </div>
        </div>
        <a-button
          class="demo__button demo__button--base"
          :disabled="nextStepDisabled"
          @click="changeStepTo3"
        >
          <span>
            {{ $t("Reg finish") }}
          </span>
          <i class="fa-light fa-chevron-right demo__margin-left--12"></i>
        </a-button>
      </div>
      <div
        class="demo__FormModal--result demo__margin-top--16"
        v-show="regResult"
      >
        {{ regResult ? regResult : false }}
      </div>
      <div class="demo__font--14 demo__weight--600 demo__margin-top--16">
        <span class="demo__color--black">
          {{ $t("Have account?") }}
        </span>
        <AuthLockBlock
          class="demo__color--brandPrimary demo__pointer demo__inline"
        >
          {{ $t("Submit") }}
        </AuthLockBlock>
      </div>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { mapGetters } from "vuex";

import FuseAutocomplete from "Components/FuseAutocomplete";

export default {
  components: {
    FuseAutocomplete,
  },
  props: {
    form: {
      required: true,
      type: Object,
    },
    regResult: {
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      apiUniversities: [],
      apiStatuses: [],
      apiSpecialties: [],
      windowWidth: window.innerWidth,
      scssRoot: () => document.getElementById("app"),
    };
  },
  computed: {
    ...mapGetters(["userLinks", "api"]),
    selectOptions() {
      return {
        specialties: this.apiSpecialties,
        professional_status: this.apiStatuses,
        university: this.apiUniversities,
      };
    },
    filteredStepFields() {
      const baseFields = [
        {
          key: "last_name",
          label: this.$t("Your last_name"),
          required: true,
        },
        {
          key: "first_name",
          label: this.$t("Your first_name"),
          required: true,
        },
        {
          key: "middle_name",
          label: this.$t("Your middle_name"),
          ru: true,
        },
      ].concat(
        process.env.VUE_APP_VERIFY === "on"
          ? [
              {
                key: "professional_status",
                label: this.$t("LK.form.labels.status"),
                required: true,
                select: {
                  mode: "single",
                },
              },
              {
                key: "specialties",
                label: this.$t("LK.form.labels.spec_med"),
                required: true,
                ru: true,
                select: {
                  mode: "multiple",
                },
              },
            ]
          : []
      );

      let additionalFields = [];

      if (
        this.form.professional_status === 3 ||
        this.form.professional_status === 2 ||
        process.env.VUE_APP_VERIFY !== "on"
      ) {
        additionalFields = [
          {
            key: "company",
            label: this.$t("Your company"),
            required: true,
          },
        ].concat(
          process.env.VUE_APP_VERIFY !== "on"
            ? [
                {
                  key: "position_in_the_company",
                  label: this.$t("Your position_in_the_company"),
                  required: true,
                },
              ]
            : []
        );
      } else if (this.form.professional_status === 1) {
        additionalFields = [
          {
            key: "university",
            label: this.$t("LK.form.labels.university"),
            required: true,
            ru: true,
            select: {
              mode: "autocomplete",
              allowCustom: true,
              onSelect: (university) => {
                this.form.university = university.id;
              },
            },
          },
        ];
      }

      console.log(additionalFields, "??F??F");

      return [...baseFields, ...additionalFields].filter((field) => {
        return this.$root.showLogic || !field.ru;
      });
    },
    nextStepDisabled() {
      return this.filteredStepFields.some((step) => {
        const value = this.form[step.key];
        if (!step.required) return false;

        if (step.key === "specialties") {
          return !value || value.length < 1;
        }
        return !value || value.length < 2;
      });
    },
    mxTagCountSelector() {
      return this.windowWidth < 500 ? 1 : 2;
    },
    mxTagTextLength() {
      return this.windowWidth < 500 ? 10 : 13;
    },
    rules() {
      return {
        last_name: [
          {
            min: 2,
            message: this.$t("Min 2"),
            trigger: "change",
          },
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "change",
          },
        ],
        first_name: [
          {
            min: 2,
            message: this.$t("Min 2"),
            trigger: "change",
          },
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "change",
          },
        ],
        company: [
          {
            min: 2,
            message: this.$t("Min 2"),
            trigger: "change",
          },
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "change",
          },
        ],
        position_in_the_company: [
          {
            min: 2,
            message: this.$t("Min 2"),
            trigger: "change",
          },
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "change",
          },
        ],
      };
    },
  },
  async created() {
    this.$accessModule("step2", this);
    this.getActualStatuses();
    this.getActualSpecialties();
    this.getUniversities();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    async getUniversities() {
      return this.api
        .getActualUniversities()
        .then((res) => {
          this.apiUniversities = res.data;
          this.$debug("Университеты загружены", "success", this.universities);
        })
        .catch((error) => {
          this.$debug("Ошибка загрузки университетов", "error", error);
        });
    },
    async getActualStatuses() {
      return this.api
        .getActualprofessional_statuses()
        .then((res) => {
          this.apiStatuses = res.data;
          this.$debug("Статусы загружены", "success", this.universities);
        })
        .catch((error) => {
          this.$debug("Ошибка загрузки статусов", "error", error);
        });
    },
    async getActualSpecialties() {
      return this.api
        .getActualSpecialties()
        .then((res) => {
          this.apiSpecialties = res.data;
          this.$debug("Cпециальности загружены", "success", this.universities);
        })
        .catch((error) => {
          this.$debug("Ошибка загрузки специальностей", "error", error);
        });
    },
    finishRegistration() {
      this.loading = true;
      this.$root.$emit("regFinish");
      if (window.ym) {
        this.$root.$emit("reachGoal", {
          goalName: "signup",
          data: {
            step: "complete",
            whereDidYouComeFrom: "register",
          },
        });
        this.$debug(
          "YA METRICS: событие signup with step complete",
          "ya_metric"
        );
      }
    },
    changeStepTo3() {
      this.finishRegistration();
    },
  },
};
</script>
